import { z } from 'zod';

export enum EventType {
  BoardMeeting = 'Board Meeting',
  CommitteeMeeting = 'Committee Meeting',
  Congress = 'Congress',
  Webinar = 'Webinar',
  Workshop = 'Workshop',
}

export enum KolProfileDataType {
  Associations = 'associations',
  Affiliations = 'affiliations',
  ClinicalTrials = 'clinical-trials',
  Collaborations = 'collaborations',
  Conferences = 'conferences',
  ContactInfo = 'contact-info',
  HCPInteractions = 'hcp-interactions',
  LeaderTopics = 'leader-topics',
  MunData = 'mun-data',
  Publications = 'publications',
  Sponsorships = 'sponsorships',
  StrategicImperatives = 'strategic-imperatives',
}
export const KolProfileDataTypeModel = z.enum(KolProfileDataType);

export const KolProfileDataTypeLabels: Record<KolProfileDataType, string> = {
  [KolProfileDataType.Associations]: 'Associations',
  [KolProfileDataType.Affiliations]: 'Affiliations',
  [KolProfileDataType.ContactInfo]: 'Contact Info',
  [KolProfileDataType.ClinicalTrials]: 'Clinical Trials',
  [KolProfileDataType.Collaborations]: 'Collaborations',
  [KolProfileDataType.Conferences]: 'Conferences',
  [KolProfileDataType.HCPInteractions]: 'HCP Interactions',
  [KolProfileDataType.LeaderTopics]: 'Leader Topics',
  [KolProfileDataType.MunData]: 'MUN Data',
  [KolProfileDataType.Publications]: 'Publications',
  [KolProfileDataType.Sponsorships]: 'Sponsorships',
  [KolProfileDataType.StrategicImperatives]: 'Strategic Imperatives',
};

export enum KolDataSource {
  CRM = 'crm',
  HcpContactInfo = 'hcp-contact-info',
  IConnect = 'iConnect',
  MeAi = 'me-ai',
  VeevaLink = 'veeva-link',
  NA = 'na',
  Unknown = 'unknown',
}

export const KolDataSourceLabels: Record<KolDataSource, string> = {
  [KolDataSource.HcpContactInfo]: 'HCP Contact Info',
  [KolDataSource.IConnect]: 'iConnect',
  [KolDataSource.MeAi]: 'ME.AI',
  [KolDataSource.VeevaLink]: 'Veeva Link',
  [KolDataSource.NA]: 'N/A',
  [KolDataSource.CRM]: 'CRM',
  [KolDataSource.Unknown]: 'Unknown',
};

export const KolProfileDataTypeSourcesMap: Record<KolProfileDataType, KolDataSource> = {
  [KolProfileDataType.Associations]: KolDataSource.VeevaLink,
  [KolProfileDataType.Affiliations]: KolDataSource.VeevaLink,
  [KolProfileDataType.ClinicalTrials]: KolDataSource.VeevaLink,
  [KolProfileDataType.Collaborations]: KolDataSource.VeevaLink,
  [KolProfileDataType.ContactInfo]: KolDataSource.HcpContactInfo,
  [KolProfileDataType.Conferences]: KolDataSource.VeevaLink,
  [KolProfileDataType.HCPInteractions]: KolDataSource.IConnect,
  [KolProfileDataType.LeaderTopics]: KolDataSource.VeevaLink,
  [KolProfileDataType.MunData]: KolDataSource.MeAi,
  [KolProfileDataType.Publications]: KolDataSource.VeevaLink,
  [KolProfileDataType.Sponsorships]: KolDataSource.VeevaLink,
  [KolProfileDataType.StrategicImperatives]: KolDataSource.NA,
};

export enum KolSearchStatusEnum {
  FormEntry = 'form-entry',
  FormSubmitted = 'form-submitted',
  FormSubmissionErrored = 'form-submission-errored',
  NoResultsReturned = 'no-results-returned',
  SingleResultReturned = 'single-result-returned',
  MultipleResultsReturned = 'results-returned',
  SearchCancelled = 'search-cancelled',
  ProfileSelectionSubmitted = 'profile-selection-submitted',
  ProfileSelected = 'profile-selected',
  ProfileSelectionErrored = 'profile-selection-errored',
  ProfileRecommendations = 'profile-recommendations',
  QuestionsBank = 'questions-bank',
}

export const KolProfileDataTypeTables: Record<KolProfileDataType, string[]> = {
  [KolProfileDataType.Associations]: ['Associations'],
  [KolProfileDataType.Affiliations]: ['Addresses'],
  [KolProfileDataType.ContactInfo]: ['PhysicianProfiles', 'ScientificExperts'],
  [KolProfileDataType.ClinicalTrials]: ['ClinicalTrials', 'ClinicalTrialRelations'],
  [KolProfileDataType.Collaborations]: ['CompanyCollaborations'],
  [KolProfileDataType.Conferences]: ['MedicalEvents', 'EventAttendees'],
  // [KolProfileDataType.Events]: ['MedicalEvents', 'EventAttendees'],
  [KolProfileDataType.HCPInteractions]: [
    'DocumentedInterestAccounts',
    'MedicalInsights',
    'MICCInteractions',
    'PhysicianMSLInteractions',
  ],
  [KolProfileDataType.LeaderTopics]: [
    'DigitalReachFocusAreas',
    'FocusAreas',
    'ClinicalLeaders',
  ],
  [KolProfileDataType.MunData]: ['AggregatedMunData', 'MunCallPlanTargets'],
  [KolProfileDataType.Publications]: ['Publications', 'PublicationRelations'],
  [KolProfileDataType.Sponsorships]: ['CompanySponsorships'],
  [KolProfileDataType.StrategicImperatives]: [],
};